export default __webpack_public_path__ + "static/media/safari_icon.413c91ae.png";